import { applyMiddleware, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import createSagaMiddleware from 'redux-saga';

import { IActivitiesState } from './modules/activities/types';
import { ICepState } from './modules/cep/types';
import { ICommentsState } from './modules/comments/types';
import { IDataListState } from './modules/dataList/types';
import { IDynamicTableState } from './modules/dynamicTable/types';
import { IImportProcessState } from './modules/importProcesses/types';
import { IModalState } from './modules/modal/types';
import { IProcessState } from './modules/processes/types';
import { IReportState } from './modules/reports/types';
import rootReducer from './modules/rootReducer';
import rootSaga from './modules/rootSaga';
import { ITaskState } from './modules/tasks/types';
import { IUserState } from './modules/users/types';

export interface IState {
  cep: ICepState;
  modal: IModalState;
  dataList: IDataListState;
  users: IUserState;
  processes: IProcessState;
  tasks: ITaskState;
  activities: IActivitiesState;
  processesInstance: IProcessState;
  reports: IReportState;
  importProcesses: IImportProcessState;
  dynamicTable: IDynamicTableState;
  comments: ICommentsState;
}

const sagaMiddleware = createSagaMiddleware();

const middlewares = [sagaMiddleware];

const store = createStore(
  rootReducer,
  composeWithDevTools(applyMiddleware(...middlewares)),
);

sagaMiddleware.run(rootSaga);

export default store;
